import React, { useState } from 'react';
import axios from 'axios';
import { Api } from './backend/auth/Configs';

const emptyForm = { name: '', organization: '', email: '', subject: '', message: '' };

const Contacts = () => {
  const [form, setForm] = useState(emptyForm);
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    setFeedback(null);
  };

  const submit = async (event) => {
    event.preventDefault();
    if (sending) return;

    setSending(true);
    setFeedback(null);
    try {
      await axios.post(`${Api}/support/messages`, form);
      setForm(emptyForm);
      setFeedback({ type: 'success', message: 'Votre message a été envoyé au support.' });
    } catch (error) {
      setFeedback({
        type: 'danger',
        message: error.response?.data?.message || "L'envoi a échoué. Veuillez réessayer plus tard.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="content2" style={{ minHeight: '680px' }}>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-9 col-lg-7">
            <h1 className="h3 text-center mb-3">Support technique</h1>
            <p className="text-center mb-4">
              Décrivez votre demande ci-dessous ou écrivez à{' '}
              <a href="mailto:support@syidocs.com">support@syidocs.com</a>.
            </p>

            {feedback && (
              <div className={`alert alert-${feedback.type}`} role="alert">
                {feedback.message}
              </div>
            )}

            <form onSubmit={submit}>
              <div className="form-group">
                <label htmlFor="support-name">Nom</label>
                <input id="support-name" name="name" className="form-control" type="text"
                  value={form.name} onChange={updateField} maxLength={100} required />
              </div>
              <div className="form-group">
                <label htmlFor="support-organization">Structure ou entreprise</label>
                <input id="support-organization" name="organization" className="form-control" type="text"
                  value={form.organization} onChange={updateField} maxLength={150} required />
              </div>
              <div className="form-group">
                <label htmlFor="support-email">Adresse e-mail</label>
                <input id="support-email" name="email" className="form-control" type="email"
                  value={form.email} onChange={updateField} maxLength={254} required />
              </div>
              <div className="form-group">
                <label htmlFor="support-subject">Objet</label>
                <input id="support-subject" name="subject" className="form-control" type="text"
                  value={form.subject} onChange={updateField} maxLength={150} required />
              </div>
              <div className="form-group">
                <label htmlFor="support-message">Message</label>
                <textarea id="support-message" name="message" className="form-control" rows="6"
                  value={form.message} onChange={updateField} maxLength={5000} required />
              </div>
              <button className="btn btn-primary" type="submit" disabled={sending}>
                {sending ? 'Envoi en cours…' : 'Envoyer au support'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
